export const createReducer = (initialState, handlers) => {
  return (state, action) => {
    if (!state) {
      state = initialState;
    }
    if (action && Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      return handlers[action.type](state, action);
    }

    return state;
  };
};
